"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = exports.NameWrapper = exports.IdentityContainer = exports.Container = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
exports.Container = styled_1.default.div({
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    overflow: 'hidden',
});
exports.IdentityContainer = styled_1.default.div({
    alignItems: 'center',
    display: 'flex',
    width: '100%',
    overflow: 'hidden',
});
exports.NameWrapper = styled_1.default.div({
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 8,
    overflow: 'hidden',
    width: '100%',
});
exports.Text = styled_1.default.div(function (_a) {
    var color = _a.color, secondary = _a.secondary;
    return ({
        color: color,
        fontSize: secondary ? 12 : 14,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    });
});
//# sourceMappingURL=styles.js.map